export class AssessmentDraftingAnalytics {
  constructor(config = {}) {
    this.url = config.analyticsUrl || ''
    this.token = config.workflowToken || ''
    this.csrfToken = config.csrfToken || ''
    this.sent = new Set()
  }

  update({ analyticsUrl, workflowToken, csrfToken } = {}) {
    if (analyticsUrl) this.url = analyticsUrl
    if (workflowToken) this.token = workflowToken
    if (csrfToken) this.csrfToken = csrfToken
  }

  send(action, dimensions = {}, logicalKey = '') {
    if (!this.url || !this.token || !this.csrfToken) return null
    const key = logicalKey || `${action}:${JSON.stringify(dimensions)}`
    if (this.sent.has(key)) return null
    this.sent.add(key)
    const eventId = this.uuid()
    return $.ajax({
      url: this.url,
      type: 'POST',
      dataType: 'json',
      data: {
        csrfmiddlewaretoken: this.csrfToken,
        workflow_token: this.token,
        event_id: eventId,
        action,
        ...dimensions,
      },
    }).fail(() => {})
  }

  uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID()
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
      const value = Math.floor(Math.random() * 16)
      return (char === 'x' ? value : (value & 0x3) | 0x8).toString(16)
    })
  }
}
